import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";
import { ActionTypeConflictProposal } from "../../api/gms/proposal/proposal-api";

export interface ConflictProposalInitial {
    approveRejectConflictProposal: {
        isShowModal: null | 'actions' | 'views';
        conflictProposalId: null | number;
        actionType: null | ActionTypeConflictProposal
    }
}

const initialState: ConflictProposalInitial = {
    approveRejectConflictProposal: {
        isShowModal: null,
        conflictProposalId: null,
        actionType: null
    },
};

const conflictProposalSlice = createSlice({
    name: 'conflictProposalSlice',
    initialState,
    reducers: {
        setApproveRejectConflictProposal: ( state, action: PayloadAction<{
            isShowModal: null | 'actions' | 'views';
            conflictProposalId: number; 
            actionType: null | ActionTypeConflictProposal
        }>) => {
            state.approveRejectConflictProposal = {
                isShowModal: action.payload.isShowModal,
                conflictProposalId: action.payload.conflictProposalId,
                actionType: action.payload.actionType,
            };
        },
        clearApproveRejectConflictProposal: (state) => {
            state.approveRejectConflictProposal = {
                isShowModal: null,
                conflictProposalId: null,
                actionType: null,
            };
        },
        clearConflictProposalState: () => initialState,
    },
});

export const {
    setApproveRejectConflictProposal,
    clearApproveRejectConflictProposal,
    clearConflictProposalState,
} = conflictProposalSlice.actions;

export default conflictProposalSlice.reducer;

export const selectApproveRejectConflictProposal = (state: RootState) => state.conflictProposalSlice.approveRejectConflictProposal;